import { render, staticRenderFns } from "./ComponentTitleWithDataLoader.vue?vue&type=template&id=42128e6b&scoped=true&"
import script from "./ComponentTitleWithDataLoader.vue?vue&type=script&lang=js&"
export * from "./ComponentTitleWithDataLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42128e6b",
  null
  
)

export default component.exports